import { useTranslation } from "react-i18next";
import GenericComponent from "../../../utils/genericComponent/GenericComponent";
import { ReactComponent as Image } from "../../../../assets/img/error-illustration.svg";

const GenericError = () => {
  const { t } = useTranslation();

  return (
    <GenericComponent
      ImageSrc={Image}
      pageTitle={t`screens.errors.genericError.title`}
      pageSubtitle={"screens.errors.genericError.subtitle"}
      buttonLabel={t`screens.errors.genericError.retry`}
      onClickCallback={() => (window.location.href = "/cb-thirdpillar/")}
    />
  );
};

export default GenericError;
